import { User } from "@/hooks/types";
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from "axios";
import { toast } from "sonner";

const BASE_URL: string = (import.meta as any).env.VITE_PROD_API_URL;

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// export function addInterceptor(user: User) {
//   axiosPrivate.interceptors.request.use(
//     (config: InternalAxiosRequestConfig) => {
//       if (!config.headers["Authorization"]) {
//         config.headers["Authorization"] = `Bearer ${user?.access_token}`;
//       }
//       return config;
//     },
//     (error: AxiosError) => Promise.reject(error)
//   );

//   axiosPrivate.interceptors.response.use(
//     (response) => response,
//     async (error: AxiosError) => {
//       const prevRequest = error.config as AxiosRequestConfig & {
//         send?: boolean;
//       };
//       if (error?.response?.status === 401 && !prevRequest.send) {
//         prevRequest.send = true;
//         localStorage.removeItem("WA-aut");
//         location.replace("/login");
//         toast.error("Session has timed out! Please Login again");
//       }
//     }
//   );
// }
